// URL configuration of every workspace, keyed by the `key` of its `workspaces` document. Branding,
// colors, navigation and feature flags live in that document; see WorkspaceService (backend and
// frontend) to load them and WorkspaceHelpers to resolve a host or origin to a workspace.
//
// Hosts are listed without protocol: localhost hosts are served over http, all others over https.

export type WorkspaceKey = 'abb' | 'currentos' | 'delta' | 'dep' | 'odca' | 'phoenixcontact' | 'schneider';

export type WorkspaceConfig = {
    key: WorkspaceKey;
    // The canonical domain, e.g. where members of a team forced onto this workspace are asked to switch to.
    primary: string;
    hosts: readonly string[];
    urls?: Record<string, () => string>;
    // The main site: branded by its document like any workspace, but not a partner workspace, so
    // catalogs, footer, navigation, emails and robots keep their default behaviour.
    main?: boolean;
};

const ABB: WorkspaceConfig = {
    key: 'abb',
    primary: 'abb.directenergypartners.com',
    hosts: ['abb.directenergypartners.com', 'abb.dcide.app', 'abb.localhost:3001'],
};

const CURRENTOS: WorkspaceConfig = {
    key: 'currentos',
    primary: 'currentos.directenergypartners.com',
    hosts: ['currentos.directenergypartners.com', 'currentos.dcide.app', 'currentos.localhost:3001'],
    urls: {
        products: () => '/currentos',
        search: () => '/currentos/search',
        manufacturers: () => '/currentos/manufacturers',
    },
};

const DEP: WorkspaceConfig = {
    key: 'dep',
    primary: 'directenergypartners.com',
    hosts: ['localhost:3000', 'localhost:3001', 'directenergypartners.com', 'dcide.app', 'staging.dcide.app'],
    main: true,
};

const DELTA: WorkspaceConfig = {
    key: 'delta',
    primary: 'delta.directenergypartners.com',
    hosts: ['delta.directenergypartners.com', 'delta.dcide.app', 'delta.localhost:3001'],
};

const ODCA: WorkspaceConfig = {
    key: 'odca',
    primary: 'odca.dcide.app',
    hosts: ['odca.dcide.app', 'odca.localhost:3001'],
    urls: {
        products: () => '/odca',
        search: () => '/odca/search',
        manufacturers: () => '/odca/manufacturers',
    },
};

const PHOENIX_CONTACT: WorkspaceConfig = {
    key: 'phoenixcontact',
    primary: 'phoenixcontact.directenergypartners.com',
    hosts: ['phoenixcontact.directenergypartners.com', 'phoenixcontact.dcide.app', 'phoenixcontact.localhost:3001'],
};

const SCHNEIDER: WorkspaceConfig = {
    key: 'schneider',
    primary: 'schneider.directenergypartners.com',
    hosts: ['schneider.directenergypartners.com', 'schneider.dcide.app', 'schneider.localhost:3001'],
};

export const WORKSPACES: Record<WorkspaceConfig['key'], WorkspaceConfig> = {
    abb: ABB,
    currentos: CURRENTOS,
    delta: DELTA,
    dep: DEP,
    odca: ODCA,
    phoenixcontact: PHOENIX_CONTACT,
    schneider: SCHNEIDER,
};
